import {
	type PartnerAddressUpdateDto,
	patchPartnersPartnerIdAddressesId,
} from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const partnerMutationsResource = Resources.base.partner.mutations;

export const useUpdateAddress = (partnerId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (args: { data: PartnerAddressUpdateDto; id: number }) =>
			patchPartnersPartnerIdAddressesId(args.data, partnerId, args.id),
		onError: (error) => {
			console.error(
				`${t(partnerMutationsResource.partnerAddressUpdateError)}:`,
				error,
			);
		},
		onSuccess: () => {
			toast.success(t(partnerMutationsResource.partnerAddressUpdateSuccess));
			queryClient.invalidateQueries({
				queryKey: ["PARTNER_DETAIL", partnerId],
			});
		},
	});
};
